export const LOCATIONS_TABLE_HEADERS = ["Id", "Label", "Address", "Time Zone", "Supervisor"];

export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1000000000;
